import { render } from "./MoveUpIcon.vue?vue&type=template&id=64ee7bae"
import script from "./MoveUpIcon.vue?vue&type=script&lang=js"
export * from "./MoveUpIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__